<template>
  <BaseModal
    name="addCommentModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('addCommentModal')"
      ></button>

      <div>
        <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
          {{ dataLang["vehicle_modal_comments_modals_text1"] }}
        </div>

        <div
          class="d-flex align-items-center justify-content-between wp-100 tw-mb-[6px]"
          ref="vehicle_comments__is_critical"
        >
          <span class="tw-app-input-container-label-type-2">
            {{ dataLang["vehicle_modal_comments_modals_text2"] }}
          </span>
          <div class="multiselect-type-2">
            <BaseSelect
              v-if="dataLang"
              style="width: 183px"
              @input="setSelected"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              v-model="selectLabel"
              label="label"
              :options="listOptions"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>
        <div class="wp-100 mb-15" ref="vehicle_comments__text">
          <BaseTextarea
            signClass="tw-text-[11px]"
            input-name="vehicle_comments__text"
            @onInput="updateValue"
            :minHeight="'160'"
            inputClass="tw-text-[11px] tw-app-input-type-2 tw-h-full"
            :name-sign="dataLang['vehicle_modal_comments_modals_text3']"
            :value="dataForEmit.vehicle_comments__text"
          >
          </BaseTextarea>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('addCommentModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["vehile_modal_btn_reset"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            {{ dataLang["vehile_modal_btn_save"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import EventBus from "@/event-bus.js";
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      selectLabel: "",
      dataForEmit: {
        vehicle_comments__text: null,
        vehicle_comments__is_critical: null,
      },
    };
  },
  methods: {
    setSelected(data) {
      this.dataForEmit.vehicle_comments__is_critical = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    beforeClose(event) {
      this.dataForEmit.vehicle_comments__text = null;
      this.dataForEmit.vehicle_comments__is_critical = null;
      this.selectLabel = "";
      Object.keys(this.dataForEmit).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.remove("input-error");
        }
      });
    },
    updateValue(data) {
      this.dataForEmit.vehicle_comments__text = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    sendData() {
      ObjectService.createComment(this.optionalParams.id, this.dataForEmit)
        .then((data) => {
          this.$toast.success("Запись добавлена");
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          this.$modal.hide("addCommentModal");
          this.dataForEmit.vehicle_comments__text = null;
          this.dataForEmit.vehicle_comments__is_critical = null;
          this.selectLabel = "";
        })
        .catch((err) => {
          Object.keys(err.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
  },
  mounted() {},
  beforeDestroy() {},

  computed: {
    listOptions() {
      return [
        {
          label: this.dataLang["no"],
          value: false,
          key: "vehicle_comments__is_critical",
        },
        {
          label: this.dataLang["yes"],
          value: true,
          key: "vehicle_comments__is_critical",
        },
      ];
    },

    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
